<template>
  <b-nav align="left"
         class="container-fluid row align-items-center fontResize">
    <div class="col-lg-1 pb-0 pt-0"
         id="genscanLogoDiv">
      <div class="col-lg-12">
        <router-link :to="{ name: 'admin.dashboard' }">
          <b-img fluid
                 :src="require('@assets/logo.svg')" />
        </router-link>
      </div>
    </div>
    <div class="col-lg-9 pb-0 pt-0">
      <div style="display:inline-block"
           v-for="route in authorizedRoutes"
           :key="route.meta.entity">
        <template v-if="getRouteChildren(route.path).length === 0 && getTotalRouteChildren(route.path).length === 0">
          <router-link
            :to="
              {
                name:
                  'admin.'
                  +
                  route.meta.entity
                  +
                  '.view'
              }"
            :class="
              $route.name.startsWith('admin.' + route.meta.entity)
                ? 'navLinkActive ml-4'
                : 'navLink ml-4'"
            @click.native="resetContext()">
            {{ $t(route.meta.readableName) }}
          </router-link>
        </template>
        <template v-else>
          <div @mouseenter="$refs['navDropdown_'+route.meta.entity][0].show()"
               @mouseleave="$refs['navDropdown_'+route.meta.entity][0].hide()">
            <b-nav-item-dropdown :ref="'navDropdown_'+route.meta.entity"
                                 style="z-index:9999;"
                                 v-if="getRouteChildren(route.path).length !== 0">
              <template v-slot:button-content>
                <span
                  :class="
                    $route.name.startsWith('admin.' + route.meta.entity)
                      ? 'navLinkActive ml-4'
                      : 'navLink ml-4'">
                  {{ $t(route.meta.readableName) }}
                </span>
              </template>
              <b-dropdown-item
                v-for="mainRoute in getMainRouteChild(route.path)"
                :key="mainRoute.meta.entity"
                :class="
                  $route.name === 'admin.' + mainRoute.meta.entity + '.view'
                    ? 'navSubLinkActive'
                    : 'navSubLink'"
                @click.native="resetContext()"
                :to="{ name: 'admin.' + mainRoute.meta.entity + '.view' }">
                {{ $t(mainRoute.meta.readableName) }}
              </b-dropdown-item>
              <b-dropdown-item v-for="childRoute in getRouteChildren(route.path)"
                               :key="childRoute.meta.entity"
                               :class="
                                 $route.name.startsWith('admin.' + route.meta.entity + '.' + childRoute.meta.entity)
                                   ? 'navSubLinkActive'
                                   : 'navSubLink'"
                               @click.native="resetContext()"
                               :to="{ name: 'admin.' + route.meta.entity + '.' + childRoute.meta.entity + '.view' }">
                {{ $t(childRoute.meta.readableName) }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </template>
      </div>
    </div>
    <div class="col-lg-2 pb-0 pt-0">
      <div class="row"
           style="align-items:center">
        <div class="col-lg-6 text-left"
             style="display:inline-block;">
          <router-link
            :to="{ name: 'admin.userdetail' }"
            @click="resetContext()"
            :class="
              $route.name == 'admin.userdetail' ? 'navLinkActive' : 'navLink'">
            {{ $auth.user() ? $auth.user().username.split('@')[0] : '' }}
          </router-link>
        </div>
        <div class="col-lg-4 text-right"
             style="display:inline-block; font-size:80%">
          <a href="#"
             class="navLink"
             @click="logout()">
            {{ $t("NavBar.Logout") }}
          </a>
        </div>
        <div class="col-2"
             style="display:inline-block">
          <LocalizationChanger />
        </div>
      </div>
    </div>
  </b-nav>
</template>
<script>
import { mapActions } from 'vuex';
import LocalizationChanger from '../LocalizationChanger';

export default {
  components: {
    LocalizationChanger
  },
  computed: {
    routeChildren() {
      return this.$router.options.routes.find((r) => r.path === '/')
        .children;
    },
    authorizedRoutes() {
      return this.routeChildren.filter(
        (r) => r.meta.includeInNavbar && this.$auth.check(r.meta.auth)
      );
    }
  },
  methods: {
    logout() {
      this.$auth.options.logoutData.redirect = '/login';
      this.$auth.logout();
    },
    getRouteChildren(route) {
      return this.routeChildren.find((r) => r.path === route)
        .children.filter((x) => x.meta.includeInNavbar && !x.meta.main && (x.meta.auth == null || this.$auth.check(x.meta.auth)));
    },
    getTotalRouteChildren(route) {
      return this.routeChildren.find((r) => r.path === route)
        .children.filter((x) => x.meta.includeInNavbar && !x.meta.main);
    },
    getMainRouteChild(route) {
      return this.routeChildren.find((r) => r.path === route)
        .children.filter((x) => x.meta.main && (x.meta.auth == null || this.$auth.check(x.meta.auth)));
    },
    ...mapActions({
      resetContext: 'dataTableFilters/resetContext'
    })
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.navLink {
  color: $text-on-primary;
  padding-bottom: 19px;
  transition: all 0.25s;
  z-index: 9999;
}

.navLink:hover {
  text-decoration: none;
  color: $text-on-primary;
  box-shadow: inset 0px -8px 0px 0px $secondary-color;
}

.navLinkActive {
  color: $text-on-primary;
  font-weight: bold;
  padding-bottom: 19px;
  box-shadow: inset 0px -4px 0px 0px $secondary-color;
  transition: all 0.25s;
  z-index: 9999;
}

.navLinkActive:hover {
  text-decoration: none;
  color: $text-on-primary;
  box-shadow: inset 0px -8px 0px 0px $secondary-color;
}

.navSubAnchorLink {
  color: $text-on-primary;
  z-index: 9999;
}

.navSubAnchorLink:hover {
  text-decoration: none;
  color: $text-on-primary;
}

.navSubLink {
  color: $text-on-primary;
  transition: all 0.25s;
  z-index: 9999;
  min-width:250px;
}

.navSubLink:hover {
  text-decoration: none;
  color: $text-on-primary;
  box-shadow: inset -8px 0px 0px 0px $secondary-color;
}

.navSubLinkActive {
  color: $text-on-primary;
  font-weight: bold;
  box-shadow: inset -4px 0px 0px 0px $secondary-color;
  transition: all 0.25s;
}

.navSubLinkActive:hover {
  text-decoration: none;
  color: $text-on-primary;
  box-shadow: inset -8px 0px 0px 0px $secondary-color;
}

@media (min-width:1481px) and (max-width:1718px) {
  .fontResize {
    font-size: 80%;
  }
}

@media (min-width:1361px) and (max-width:1480px) {
  .fontResize {
    font-size: 70%;
  }
}

@media (min-width:1200px) and (max-width:1360px) {
  .fontResize {
    font-size: 60%;
  }
}
</style>
